
import Vue from 'vue'

const component = Vue.extend({})

Vue.component('AArrival', component)
export default component
